@use '@lib/assets/styles/main' as *;
@use '@lib/components/Typography/TypographyExtends' as *;

.tooltip {
  @extend %dropDownStyle;
  min-width: 100px;
  font-family: inherit;
  padding: 0 0 8px;
}

.title {
  font-weight: 600;
  margin-bottom: 8px;
  color: #374151;
  background-color: $blue50;
  padding: 6px 8px;
}

.list {
  padding: 4px 0;
}

.tooltipRow {
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 20px;
  & + .tooltipRow {
    margin-top: 10px;
  }
}

.colorIndicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}

.entityName {
  @include small;
  color: $gray500;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 4px;
}

.value {
  @include small;
  color: $gray900;
}
